export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10487.8ed4ff12.jpg";